import Divider from '@mui/material/Divider';
import { css } from 'styled-components';

export const TABLE_BG_COLOR = '#0E202E';
export const BORDER_COLOR = `rgba(236, 236, 236, 0.08)`;

export const HPDivider = ({ style }: { style?: React.CSSProperties }) => (
  <Divider
    css={css`
      border-color: ${BORDER_COLOR};
      width: 95%;
      margin: 0 auto;
    `}
    style={style}
  />
);
